/** Login and CMS dashboard routes always use LTR layout. */
export function isAdminAppRoute(pathname) {
  return pathname === '/login' || pathname.startsWith('/dashboard');
}
